import styled from "styled-components/macro";
import React, {useEffect} from "react";
import {ArrowRightBlue, Error} from "../../icon/Icon";
import {Body1, Body2} from "../../components/Font";
import {useTheme} from "styled-components";
import {WindowSizePXEnum} from "../../interface/Basic/window";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {GetLKLink} from "./Security/api/slice";
import {useTranslation} from "react-i18next";
import {TabsEnum} from "./Passport";

export interface ITab {
    id: TabsEnum
    name: string

    icon(active: boolean): React.ReactElement

    error?: boolean
}

export interface ITabProps {
    selected: boolean
    error?: boolean
}

export interface SideBarProps {
    tabs: ITab[]
    currentTab: ITab
    mobileMenuOpen: boolean

    setMobileMenuOpen(): void

    onTabClick(value: ITab): void

}

export const SideBar = ({onTabClick, tabs, currentTab, mobileMenuOpen, setMobileMenuOpen}: SideBarProps) => {

    const theme = useTheme()
    const dispatch = useAppDispatch()
    const {t} = useTranslation();
    const {lkLink} = useAppSelector(state => state.security)

    useEffect(() => {
       dispatch(GetLKLink())
    },[])

    const Links = () => {
        return <>
            {lkLink && <SideBarLink target={'_blank'} href={lkLink}>
                <Body2>
                    {t('passport.goToLK')}
                </Body2>
                <ArrowRightBlue/>
            </SideBarLink>}
            <SideBarLink target={'_blank'} href={'https://ab.rudn.ru'}>
                <Body2>
                    {t('passport.goToAB')}
                </Body2>
                <ArrowRightBlue/>
            </SideBarLink>
        </>
    }

    return <><SideBarContainer>
        {tabs.map((tab, index) => <Tab
            onClick={() => onTabClick(tab)}
            key={index}
            selected={tab.id === currentTab.id}>
            {tab.icon(tab.id === currentTab.id)}
            <Body1 color={tab.id === currentTab.id ? theme.color.indicator : theme.color.secondary}>
                {tab.name}
            </Body1>
            {tab.error && <ErrorContainer>
                <Error/>
            </ErrorContainer>}
        </Tab>)}
        <Links/>
    </SideBarContainer>
        {mobileMenuOpen &&
            <>
                <TabletBackground/>
                <MobileBarContainer>
                    {tabs.map((tab, index) => <Tab
                        onClick={() => {
                            onTabClick(tab)
                            setMobileMenuOpen()
                        }}
                        key={index}
                        selected={tab.id === currentTab.id}>
                        {tab.icon(tab.id === currentTab.id)}
                        <Body1 color={tab.id === currentTab.id ? theme.color.indicator : theme.color.secondary}>
                            {tab.name}
                        </Body1>
                        {tab.error && <ErrorContainer>
                            <Error/>
                        </ErrorContainer>}
                    </Tab>)}
                    <Links/>
                </MobileBarContainer>
            </>
        }
    </>
}

const SideBarContainer = styled.div`
  display: flex;
  width: 280px;
  flex-direction: column;
  gap: 5px;
  @media (max-width: ${WindowSizePXEnum.md}) {
    display: none;
  }
`

const Tab = styled.div<ITabProps>`
  display: flex;
  width: 100%;
  gap: 12px;
  cursor: pointer;
  align-items: center;
  padding: 12px 10px;
  border-radius: 8px;
  position: relative;
  user-select: none;
  :hover{
    background: #E9EBED;
  }
`
const ErrorContainer = styled.div`
  display: flex;
  position: absolute;
  right: 14px
`

const MobileBarContainer = styled.div`
  overflow-x: hidden;
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: white;
  top: 56px;
  left: 0;
  padding: 20px;
  @media (max-width: ${WindowSizePXEnum.md}) {
    width: 328px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
  }
`
const TabletBackground = styled.div`
  display: none;
  overflow-x: hidden;
  @media (max-width: ${WindowSizePXEnum.md}) {
    display: unset;
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    height: 100vh;
    width: 100%;
    z-index: 10;
    top: 0;
    left: 0;
  }
`
const SideBarLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 15px;
  margin: 0;
  cursor: pointer;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  color: ${({theme}) => theme.color.indicator};
  text-decoration: none;
  :visited {
    color: ${({theme}) => theme.color.indicator};
  }
  svg {
    min-height: 24px;
    max-height: 24px;
    min-width: 24px;
    max-width: 24px;
  }
`